import SurveyTable from './lib/table';
import { useTypedSelector } from 'common/hooks/useTypedSelector';

import PageTitle from 'components/pageTitle';

import * as S from './styles';
import SurveyCounts from './lib/surveyCounts';

export default function SurveyPage() {
  const { surveys } = useTypedSelector((state) => state.Survey);

  return (
    <S.Container>
      <PageTitle title="Survey System" />
      <S.Head>
        <SurveyCounts data={{}} />
      </S.Head>
      <SurveyTable data={surveys.data} loading={surveys.loading} />
    </S.Container>
  );
}
